import { render, staticRenderFns } from "./CustomerEmailCard.vue?vue&type=template&id=1a99bedc&"
import script from "./CustomerEmailCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerEmailCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports